import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    var date = moment(value).format(" dddd,Do MMMM YYYY");
    return date
  }
})

Vue.filter('getDate', function(value) {
  if (value) {
    var date = moment(value).format("D");
    return date
  }
})

Vue.filter('getMonth', function(value) {
  if (value) {
    var date = moment(value).format("MMMM");
    return date
  }
})

Vue.filter('formatTime', function(value) {
  if (value) {
    var time = moment(value).format(" HH:mm ");
    return time
  }
})
Vue.filter('trimText', function(value, maxLength) {
  return value && value.length > maxLength ? value.substr(0, maxLength - 3) + "..." : value
})
Vue.filter('date2', function(value) {
  if(value) {
    var time = moment(value).format("MM/DD");
    return time
  }
})



// WEBPACK FOOTER //
// ./src/filters/index.js